// ===============================
// AUTO PARTES - CUSTOM.JS
// ===============================

// ---------------------------------
// Redirecciones
// ---------------------------------
window.onload = function () {
  var currentURL = window.location.href.toLowerCase();

  var keywordRedirects = {
    "https://www.auto-magic.com.mx/collections/faros%20de%20niebla":
      "https://www.auto-magic.com.mx/collections/faros-de-niebla"
  };

  for (var keyword in keywordRedirects) {
    if (currentURL.indexOf(keyword.toLowerCase()) > -1) {
      window.location.href = keywordRedirects[keyword];
      return;
    }
  }
};


// ---------------------------------
// Menú móvil
// ---------------------------------
document.addEventListener("DOMContentLoaded", function () {

  var buttons = document.querySelectorAll(".site-nav__link--button");

  buttons.forEach(function(button){

    button.addEventListener("click", function(){

      var dropdownId = button.getAttribute("aria-controls");
      var dropdown = document.getElementById(dropdownId);
      var isOpen = button.getAttribute("aria-expanded") === "true";

      document.querySelectorAll(".site-nav__dropdown").forEach(function(d){
        d.classList.remove("is-visible");
      });

      document.querySelectorAll(".site-nav__link--button").forEach(function(b){
        b.setAttribute("aria-expanded","false");
      });

      if(!isOpen && dropdown){
        dropdown.classList.add("is-visible");
        button.setAttribute("aria-expanded","true");
      }

    });

  });

});


// ---------------------------------
// Buscador inteligente
// ---------------------------------
document.addEventListener("submit", function(event){

    var form = event.target;

    if(!form.matches('form[action="/search"], form[action*="/search"]')){
        return;
    }

    var input = form.querySelector('input[name="q"]');

    if(!input) return;

    var value = input.value.trim();

    // =============================
    // SKU
    // =============================
    var skuPattern = /^[A-Za-z]{2,6}-[A-Za-z0-9]+$/;

    if(skuPattern.test(value)){
        input.value = 'variants.sku:"' + value.toUpperCase() + '"';
        return;
    }

    // =============================
    // Convertir años
    // =============================
    value = value.replace(/\b20(\d{2})\b/g, "$1");
    value = value.replace(/\b19(\d{2})\b/g, "$1");

    // =============================
    // Buscar siempre por título
    // =============================
    input.value = 'title:"' + value + '"';

}, true);